import { useState } from "react";
import { Header } from "./components/Header";
import { TabSwitch, type Tab } from "./components/TabSwitch";
import { Deposit } from "./components/Deposit";
import { Withdraw } from "./components/Withdraw";
import { Notes } from "./components/Notes";
import { VeTonado } from "./components/VeTonado";
import { GovernancePanel } from "./components/Governance";
import { AmClaim } from "./components/AmClaim";
import { Relayers } from "./components/Relayers";
import { Footer } from "./components/Footer";
import { Background } from "./components/Background";
import { DevCeremonyBanner } from "./components/DevCeremonyBanner";

export function App() {
  const [tab, setTab] = useState<Tab>("deposit");

  return (
    <div className="app">
      <Background />
      <DevCeremonyBanner />
      <Header />
      <main className="app__main">
        <div className="app__intro">
          <p className="kicker">
            <span className="kicker-dot" /> Privacy pool · TON
          </p>
          <h1>
            Deposit. <em>Disappear.</em>
            <br />
            Withdraw anywhere.
          </h1>
          <p className="lede">
            A note encodes a withdrawal right. Keep it safe - it's bearer cash. Generate one,
            deposit a fixed denomination, and redeem later from any wallet without revealing which
            deposit was yours.
          </p>
        </div>

        <TabSwitch value={tab} onChange={setTab} />

        <section className="app__panel" aria-live="polite">
          {tab === "deposit" && <Deposit />}
          {tab === "withdraw" && <Withdraw />}
          {tab === "notes" && <Notes />}
          {tab === "ve" && <VeTonado />}
          {tab === "gov" && <GovernancePanel />}
          {tab === "am" && <AmClaim />}
          {tab === "relayers" && <Relayers />}
        </section>
      </main>
      <Footer />
    </div>
  );
}
